import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Layout, Typography, Switch } from 'antd';
import {MenuFoldOutlined, MenuUnfoldOutlined} from "@ant-design/icons";

import './Header.scss'

import { readAll } from '../../../redux/notification/notification.actions';
import { markAllOrderAsRead } from '../../services/http/PedidoService';
import {getUser} from '../../services/UserService';
import Notifications from "../notifications/Notifications";

const { Header } = Layout

class UpGasHeader extends React.Component {
  state = {
    settingsVisible: false,
  }

  onMarkAllAsRead = () => {
    const { id } = getUser()
    markAllOrderAsRead(id)
    this.props.readAll()
  }

  render() {
    const { isCollapsed, onToggle, notifications, onNotificationClick, toggleSoundMute, muted } = this.props

    return (
      <Header className="header-container">
        <div className="menu-icon-container">
          {isCollapsed ? <MenuUnfoldOutlined className="trigger" onClick={onToggle} /> : <MenuFoldOutlined className="trigger" onClick={onToggle} />}
        </div>
        <div className="header-options-container">
          <div>
            <Typography.Text className="mr-10">Sons de aviso</Typography.Text>
            <Switch checked={!muted} onChange={toggleSoundMute} />
          </div>
          <Notifications notifications={notifications} onNotificationClick={onNotificationClick} onMarkAllAsRead={this.onMarkAllAsRead} />
        </div>
      </Header>
    )
  }
}

const mapActionToProps = dispatch => bindActionCreators({ readAll }, dispatch)

const mapStateToProps = state => ({ notifications: state.notifications })

UpGasHeader = connect(
  mapStateToProps,
  mapActionToProps
)(UpGasHeader)

export default withRouter(UpGasHeader)
